import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import Buefy from 'buefy'
import Toasted from 'vue-toasted';
import VTooltip from 'v-tooltip'



import "./assets/main.scss";


Vue.config.productionTip = false;
Vue.use(Buefy, { defaultIconPack: 'fas' })
Vue.use(Toasted, { position: 'top-center', duration: 5000 })
Vue.use(VTooltip)
Vue.mixin({
	methods: {
		capitalizeFirstLetter: (str) => {
      console.log("CFIRST")
			if (!str) {
				return ""
			}
			return str.charAt(0).toUpperCase() + str.slice(1)
		},
		
	},
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
